import Styled from 'styled-components'

export const Filter = Styled.fieldset`
`
export const Line = Styled.div`
`

export const Preço = Styled.div`
`
export const ContainerButton = Styled.div`
`